export default {
  // Màn quản lý dữ liệu
  DataManagement: {
    DataManagement: 'Quản lý dữ liệu',
    HistoryDataManagement: 'Lịch sử quản lý dữ liệu',
    AddData: 'Thêm dữ liệu',
    CreatedDate: 'Ngày tạo:',
    CreatedBy: 'Người tạo',
    Working: 'ĐANG LÀM VIỆC',
    DataError: 'DỮ LIỆU LỖI',
    NotWorking: 'KHÔNG LÀM VIỆC',
    NotifyEmpty:
      'Đây là lần đầu tiên bạn làm việc với chương trình. <br />Vui lòng tạo dữ liệu kế toán mới để tiếp tục làm việc',
    BackupAndRestore: 'Sao lưu và phục hồi dữ liệu',
  },
  // Màn sao lưu
  BackupData: {
    NotiftyExprise:
      'Mỗi bản sao lưu chỉ được lưu trữ tối đa<span> 180 ngày</span>. Mỗi dữ liệu không quá<span> 3 bản.</span>',
    TitleConfirmDelete: 'Xóa dữ liệu sao lưu',
    MessageConfirmDelete:
      'Bạn đang thực hiện xóa bản sao lưu dữ liệu <span class="bold">{0}</span> <br/> ngày {1}.Bạn có chắc chắn muốn xóa không?',
    ActionGrid: {
      CancelBackup: 'Hủy sao lưu',
      Recover: 'Phục hồi',
    },
    TitleNotifyBackup: 'Dữ liệu đang phục hồi',
    MessageNotifyBackup:
      'Bạn không thể thực hiện Phục hồi bản sao lưu <span class="bold">{0}</span> cho đến khi nhận được thông báo hoàn thành quá trình phục hồi.',
    Cancel: 'Hủy',
  },
  // Popup lịch sử quản lý dữ liệu
  HistoryDataManagement: {
    Period: 'Khoảng thời gian',
    From: 'Từ',
    To: 'Đến',
    GetData: 'Lấy dữ liệu',
  },
  // Popup đổi tên dữ liệu
  RenameData: {
    Title: 'Đổi tên dữ liệu',
    NameData: 'Tên dữ liệu',
  },
  // Popup thay đổi nội dung kế toán
  AccountingDataInformation: {
    Title: 'Thông tin về dữ liệu kế toán',
    AccountingData: 'Dữ liệu kế toán',
    AccountingDataName: 'Tên DLKT:',
    AccountingDataNameTooltip: 'Tên dữ liệu kế toán',
    Version: 'Phiên bản:',
    AccountingInformation: 'Thông tin kế toán',
    AccountMode: 'Chế độ kế toán:',
    BookkeeppingMode: 'Chế độ ghi sổ',
    StartDate: 'Ngày bắt đầu:',
    CloseDate: 'Ngày khóa sổ:',
    IsUpdateCircular: 'Đã cập nhật TT-QĐ:',
    IsUpdateCircularTooltip: 'Đã cập nhật thông tư - quyết định',
    Special: 'Đặc thù:',
  },
  // Popup chọn dữ liệu kế toán
  SelectAccountingData: {
    Title: 'Chọn dữ liệu kế toán',
    OrganizationWorking: 'Đơn vị đang làm việc',
    Data: 'Dữ liệu',
    ChooseOrganizationOther: 'Chọn đơn vị khác',
    ChooseDataOther: 'Chọn dữ liệu khác',
  },
  // Tạo dữ liệu kế toán
  CreateData: {
    Step1: 'Khai báo thông tin dữ liệu',
    Step2: 'Tùy chọn',
    Step3: 'Thực hiện',
    TitleStep1: 'Khai báo thông tin dữ liệu',
    OrganizationName: 'Tên đơn vị',
    DataName: 'Tên dữ liệu *',
    AccountingMode: 'Chế độ kế toán',
    AccountingDate: 'Ngày hạch toán *',
    AccountingCurrency: 'Đồng tiền hạch toán',
    NoteStep1: 'Bạn chỉ nhập được số dư ban đầu tính đến trước {0} và hạch toán các nghiệp vụ phát sinh từ ngày này.',
    Cancel: 'Hủy bỏ',
    TitleStep2: 'Tùy chọn nghiệp vụ',
    BusinessUse: 'Nghiệp vụ sử dụng',
    FollowBasicContructorAccounting: 'Theo dõi kế toán xây dựng cơ bản',
    NoteStep2OP1:
      'Đơn vị có theo dõi dự án đầu tư từ nguồn ngân sách cấp xã thuộc thẩm quyền phê duyệt của Chủ tịch UBND xã.',
    FollowAssetTracking: 'Theo dõi tài sản hạ tầng giao thông, thủy lợi',
    NoteStep2OP2:
      'Đơn vị có tài sản hạ tầng giao thông, thủy lợi (Đáp ứng thông tư số 76/2019/TT-BTC về hướng dẫn kế toán tài sản kết cấu hạ tầng giao thông thủy lợi).',
    ConnectAnotherApp: 'Kết nối phần mềm khác',
    ConnectMISAQLTS: 'Kết nối MISA QLTS',
    DescriptionConnectMISAQLTS:
      'Đơn vị theo dõi tài sản chi tiết trên MISA QLTS, chỉ dùng Bamboo để hạch toán kế toán.',
    ConnectMISASalagov: 'Kết nối MISA SalaGov',
    DescriptionConnectMISASalagov:
      'Đơn vị tính lương hệ số, phụ cấp...trên MISA SalaGov, chỉ dùng Bamboo để hạch toán kế toán.',
    Perform: 'Thực hiện',
    CreateAccountingData: 'Tạo dữ liệu kế toán',
    CreatingAccountingData: 'Đang tạo dữ liệu kế toán',
    One: '1',
    Two: '2',
    Three: '3',
    DeclareDataInformation: 'Khai báo thông tin dữ liệu',
    OptionBusiness: 'Tùy chọn nghiệp vụ',
    CompanyInfo: 'Thông tin đơn vị',
    CreateDatabase: 'Tạo dữ liệu kế toán'
  },
  CreateDataPrevYear: {
    Description: 'Hệ thống sẽ tạo dữ liệu mới từ dữ liệu năm trước đã được chọn.',
    RetrieveBalanceAdjustDocument: 'Không lấy số dư đầu kỳ',
    Notify:
      'Chương trình đang thực hiện khởi tạo dữ liệu kế toán <span class="bold">{0}</span>. Theo dõi tiến trình tạo dữ liệu  tại <span class="bold">Quản lý dữ liệu.</span> Chương trình sẽ gửi thông báo khi quá trình khởi tạo hoàn tất.',
    NewDataName: 'Tên dữ liệu mới *',
    ChooseData: 'Chọn dữ liệu *',
    YearData: 'Dữ liệu năm {0}',
    AccountingSystem: 'Thông tư 70/2019/TT-BTC ngày 03/10/2019 của Bộ Tài chính',
    CreatingData: 'Đang tạo dữ liệu kế toán',
    CreatingDataInfo: 'Chương trình đang thực hiện khởi tạo dữ liệu kế toán {0}. Theo dõi tiến trình tạo dữ liệu tại Quản lý dữ liệu. Chương trình sẽ gửi thông báo khi quá trình khởi tạo hoàn tất.'
  },
  BackupAccountingDataPopup: {
    Title: 'Sao lưu dữ liệu kế toán',
    Backup: 'Sao lưu',
    CancelBackup: 'Hủy sao lưu',
    AccessDataAnother: 'Truy cập dữ liệu khác',
    Cancel: 'Hủy',
    BackupData: 'Dữ liệu sao lưu: ',
    NameDescription: 'Tên dữ liệu sao lưu',
    Note: 'CHÚ Ý:',
    NoteDescription:
      'Để đảm bảo tính đúng đắn của dữ liệu, bạn sẽ <span class="bold">không thể truy cập vào dữ liệu</span> trong quá trình sao lưu.',
    NotifyDescription: 'Hệ thống sẽ gửi thông báo đến email </br> <span class="link">{0}</span> sau khi hoàn thành.',
    SaveFiveYear: 'Lưu trữ 5 năm (Chỉ được lưu trữ 1 dữ liệu)',
    OverNumberBackupTitle: 'Vượt quá số lần sao lưu',
    DelBackupFile: 'Xóa bản sao lưu',
    LoginToOtherDb: 'Truy cập vào dữ liệu khác',
  },
  ConfirmDeletePopup: {
    Title: 'Cảnh báo xóa dữ liệu kế toán',
    Notify: 'Bạn đang thực hiện <span class="bold text-danger">xóa dữ liệu kế toán {0}</span>',
    Note: 'Chú ý: ',
    NoteDescription:
      'Dữ liệu đã xóa không thể truy cập và phục hồi lại được. Bạn chỉ nên sử dụng tính năng này khi chắc chắn dữ liệu đang chọn là không cần thiết và không có nhu cầu sử dụng lại sau này.',
    AcceptAllRight: 'Tôi đồng ý xóa và tự chịu trách nhiệm về các vấn đề phát sinh nếu có',
    RemoveData: 'Xóa dữ liệu',
  },
  ChangeDatabaseUsePopup: {
    Title: 'Chọn dữ liệu làm việc',
    Agree: 'Đồng ý',
    Cancel: 'Hủy bỏ',
  },
  RestoreAccountingDataPopup: {
    Title: 'Phục hồi dữ liệu kế toán',
    RestoreNote:
      'Thời gian phục hồi phụ thuộc vào độ lớn dữ liệu. Vui lòng chờ cho đến khi nhận được thông báo từ hệ thống',
    BackupDataTit: 'Dữ liệu sao lưu:',
    BackupTimeTit: 'Thời gian sao lưu:',
    RestoreNameTit: 'Tên dữ liệu sau phục hồi',
    Restore: 'Phục hồi',
    Cancel: 'Hủy bỏ',
  },
};
